import React, { memo, useEffect, useState } from 'react';
import SanitiseIcon from '../../assets/RichTeIcons/sanitise-inactive.svg';
import {
  SanitiseButtonIcon,
  ToolButton,
  ToolButtonWrapper,
} from './ToolBarStyles';
import ToolTip from './ToolTip';

interface SanitiseProps {
  onChange: (value: boolean) => void;
}

export default memo(({ onChange }: SanitiseProps) => {
  const [sanitiseState, updateSanitiseState] = useState(false);
  const [tooltipIsVisible, setTooltipIsVisible] = useState<boolean>(false);

  const toggleSanitise = (): void => {
    updateSanitiseState(!sanitiseState);
  };

  useEffect(() => {
    onChange(sanitiseState);
  }, [onChange, sanitiseState]);

  return (
    <ToolButtonWrapper>
      <ToolTip text="sanitise" isVisible={tooltipIsVisible}>
        <ToolButton
          type="button"
          onClick={toggleSanitise}
          onMouseEnter={() => {
            setTooltipIsVisible(true);
          }}
          onMouseLeave={() => {
            setTooltipIsVisible(false);
          }}
        >
          <SanitiseButtonIcon src={SanitiseIcon} $isActive={sanitiseState} />
        </ToolButton>
      </ToolTip>
    </ToolButtonWrapper>
  );
});
